import { useSnackbar, SnackbarMessage, VariantType, OptionsObject } from "notistack"
import { CloseAction } from "./components/CloseAction";
import { useTheme } from "@mui/material"

const useCustomSnackbar = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const theme = useTheme();

	const successSnackbar = (message: string, preventDuplicate?: boolean, autoHideDuration?: number) => {
		return enqueueSnackbar(getSnackbarConfig(message, "success", 5000, preventDuplicate, autoHideDuration))
	}
	
	const errorSnackbar = (message: string, preventDuplicate?: boolean, autoHideDuration?: number) => {
		return enqueueSnackbar(getSnackbarConfig(message, "error", 10000, preventDuplicate, autoHideDuration));
	}

	const warningSnackbar = (message: string, preventDuplicate?: boolean, autoHideDuration?: number) => {
		return enqueueSnackbar(getSnackbarConfig(message, "warning", 10000, preventDuplicate, autoHideDuration));
	}
	
	const infoSnackbar = (message: string, preventDuplicate?: boolean, autoHideDuration?: number) => {
		return enqueueSnackbar(getSnackbarConfig(message, "info", 10000, preventDuplicate, autoHideDuration));
	}

	const processInProgressSnackbar = (message: string, persist?: boolean, preventDuplicate?: boolean) => {
		return enqueueSnackbar({
			message,
			variant: "proccesInProgress",
			anchorOrigin: {
				horizontal: "right",
				vertical: "top"
			},
			persist,
			preventDuplicate
		});
	}

	const getSnackbarConfig = <V extends VariantType>(message: string, variant: V, defaultAutoHideDuration: number, preventDuplicate?: boolean, autoHideDuration?: number): OptionsObject<V> & { message?: SnackbarMessage } => ({
		message,
		variant,
		anchorOrigin: {
			horizontal: "right",
			vertical: "top"
		},
		preventDuplicate,
		autoHideDuration: autoHideDuration || defaultAutoHideDuration,
		action: CloseAction(theme.palette.common.white)
	})	

	return {
		successSnackbar,
		errorSnackbar,
		warningSnackbar,
		processInProgressSnackbar,
		infoSnackbar,
		closeSnackbar
	}
}

export default useCustomSnackbar;